import httpClient from '@/services/http.client';
import config from '@/config';
import store from '@/store';
import i18n from '@/i18n';
import router from '@/router';
import auth from '../auth.services';

const host = config.serverHost;
httpClient.defaults.baseURL = config.serverHost;

export default () => {
  httpClient.interceptors.request.use((cfg) => {
    const token = store.state.auth.token;
    const lang = i18n.locale;
    if (token && cfg.baseURL === host && !cfg.headers.Authorization) {
      cfg.headers.Authorization = `Bearer ${token}`;
      cfg.headers['Accept-Language'] = lang;
      cfg.headers['Url-Form'] = window.location.pathname;
    }
    return cfg;
  });

  httpClient.interceptors.response.use(
    (response) => {
      if (!response.status) return Promise.reject('Server not Found!');

      if (response.data) {
        // Logout automático quando a sessão estiver finalizada
        if (response.data.code && ['002', '003'].includes(response.data.code)) {
          auth.logout();
          router.replace('/');
          return Promise.reject('Sessão finalizada!');
        }
      }
      return response;
    },
    (error) => {
      if (error.response && error.response.data) {
        // Logout automático quando a sessão estiver finalizada
        if (error.response.data.code && ['002', '003'].includes(error.response.data.code)) {
          auth.logout();
          router.replace('/');
          return Promise.reject('Sessão finalizada!');
        }
      }
      return Promise.reject(error);
    }
  );
};
